// Événements analytics (migration de PlausibleEvents)
export enum AnalyticsEvent {
  // Session lifecycle
  SESSION_STARTED = 'session_started',
  SESSION_ENDED = 'session_ended',
  SESSION_CANCELLED = 'session_cancelled',

  // User interactions
  IDLE_MODAL_RENDERED = 'idle_modal_rendered',
  LOGOUT_FROM_IDLE_MODAL = 'logout_from_idle_modal',

  // Interview
  STARTED_INTERVIEW = 'started_interview',
  ENDED_INTERVIEW = 'ended_interview',

  // CV actions
  DOWNLOADED_CV = 'downloaded_cv',
  PRINTED_CV = 'printed_cv',
  REACHED_PRINT_STEP = 'reached_print_step',

  // Jobs
  JOB_LISTED = 'job_listed',
  JOB_CARD_CLICKED = 'job_card_clicked',
  APPLY_TO_JOB = 'apply_to_job',
  JOBS_LIST_SCREEN_RENDERED = 'jobs_list_screen_rendered',

  // Registration & Payment
  NEXT_REGISTER_STEP = 'next_register_step',
  PAYMENT_SUCCEEDED = 'payment_succeeded',
  /** Emitted when payment is captured (debited) at end of interview (CV generation). */
  PAYMENT_CAPTURED = 'payment_captured',
}
